import { CurrencyNgnIcon } from './CurrencyNgnIcon';

/**
 * author: Austin Andrews
 * id 2F091499-4472-423E-A0C5-8C96CDDE1ABF
 * name currency-ngn
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/currency-ngn.svg
 * tags
 * - Currency 
 * - Banking 
 */
export const NairaIcon = CurrencyNgnIcon;
export default NairaIcon